import React, { useContext } from 'react';
import { Nav } from 'reactstrap';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SimpleBar from 'simplebar-react';
import SidebarData, { SIDEBAR_OPTIONS } from '../sidebardata/SidebarData';
import Logo from '../../logo/Logo';
import NavItemContainer from './NavItemContainer';
import NavSubMenu from './NavSubMenu';
import { AuthContext } from '../../../context/authContext';
import { getItem, STORAGE_KEYS } from '../../../services/storage';

const DESCUENTOS_ALLOWED_EMAILS = [
  'asanjose@cedetecgroup.com',
  'nfeneux@cedetecgroup.com',
  'ajimenez@cedetecgroup.com',
];
const PRESUPUESTOS_ALLOWED_EMAILS = [
  'asanjose@cedetecgroup.com',
  'nfeneux@cedetecgroup.com',
  'ajimenez@cedetecgroup.com',
];

const Sidebar = () => {
  const location = useLocation();
  const currentURL = location.pathname.split('/').slice(0, -1).join('/');

  //const [collapsed, setCollapsed] = useState(null);
  // const toggle = (index) => {
  //   setCollapsed(collapsed === index ? null : index);
  // };

  const activeBg = useSelector((state) => state.customizer.sidebarBg);
  const isFixed = useSelector((state) => state.customizer.isSidebarFixed);
  const { userOU } = useContext(AuthContext);
  const userSession = getItem(STORAGE_KEYS.USER);
  const userEmail = userSession?.profileObj?.email;
  const puedeVerDescuentos = DESCUENTOS_ALLOWED_EMAILS.includes(userEmail);
  const puedeVerPresupuestos = PRESUPUESTOS_ALLOWED_EMAILS.includes(userEmail);

  return (
    <div className={`sidebarBox shadow bg-${activeBg} ${isFixed ? 'fixedSidebar' : ''}`}>
      <SimpleBar style={{ height: '100%' }}>
        {/********Logo*******/}
        <div className="d-flex p-3 align-items-center">
          <Logo />
        </div>
        {/********Sidebar Content*******/}
        <div className="p-3 pt-1 mt-2">
          <Nav vertical className={activeBg === 'white' ? '' : 'lightText'}>
            {SidebarData.map((navi) => {
              if (navi.caption) {
                return (
                  <div className="navCaption fw-bold mt-4" key={navi.caption}>
                    {navi.caption}
                  </div>
                );
              }

              if (navi.children) {
                return (
                  <NavSubMenu
                    key={navi.id}
                    icon={navi.icon}
                    title={navi.title}
                    items={navi.children}
                    suffix={navi.suffix}
                    suffixColor={navi.suffixColor}
                    // toggle={() => toggle(navi.id)}
                    // collapsed={collapsed === navi.id}
                    isUrl={currentURL === navi.href}
                  />
                );
              }

              // Soporte (tickets): Administradores/IT y Secretaria, alineado
              // con la ruta /tickets (PrivateRoute SUPERADMIN+SECRETARIA).
              // Los roles permitidos caen al bloque general de abajo, que
              // pinta el item.
              if (
                navi.id === SIDEBAR_OPTIONS.TICKETS &&
                !(userOU.idCedesca === 0 && userOU.idCntec === 0) &&
                !(userOU.idCedesca === -3 && userOU.idCntec === -3)
              ) {
                return <div key={navi.id}></div>;
              }

              // Descuentos: solo Administradores/IT y emails autorizados (Alba, Natalia)
              if (navi.id === SIDEBAR_OPTIONS.DESCUENTOS) {
                const isAdmin = userOU.idCedesca === 0 && userOU.idCntec === 0;
                if (isAdmin || puedeVerDescuentos) {
                  return (
                    <NavItemContainer
                      key={navi.id}
                      id={navi.id}
                      className={location.pathname === navi.href ? 'activeLink' : ''}
                      to={navi.href}
                      title={navi.title}
                      suffix={navi.suffix}
                      suffixColor={navi.suffixColor}
                      icon={navi.icon}
                    />
                  );
                }
                return <div key={navi.id}></div>;
              }

              // Presupuestos: solo Administradores/IT y emails autorizados (Alba, Natalia)
              if (navi.id === SIDEBAR_OPTIONS.PRESUPUESTOS) {
                const isAdmin = userOU.idCedesca === 0 && userOU.idCntec === 0;
                if (isAdmin || puedeVerPresupuestos) {
                  return (
                    <NavItemContainer
                      key={navi.id}
                      id={navi.id}
                      className={location.pathname === navi.href ? 'activeLink' : ''}
                      to={navi.href}
                      title={navi.title}
                      suffix={navi.suffix}
                      suffixColor={navi.suffixColor}
                      icon={navi.icon}
                    />
                  );
                }
                return <div key={navi.id}></div>;
              }

              // Uusario con rol Administrador/IT
              // Lo ve todo
              if (userOU.idCedesca === 0 && userOU.idCntec === 0) {
                return (
                  <NavItemContainer
                    key={navi.id}
                    id={navi.id}
                    //toggle={() => toggle(navi.id)}
                    className={location.pathname === navi.href ? 'activeLink' : ''}
                    to={navi.href}
                    title={navi.title}
                    suffix={navi.suffix}
                    suffixColor={navi.suffixColor}
                    icon={navi.icon}
                  />
                );
              }

              // Usuario con rol de Delegación
              // Solo "Alumnos" y "Matrículas" - de sus alumnos.
              // Basta pertenecer a UNA empresa (id > 0). Las delegaciones de una
              // sola sede traen la otra en null; usar > 0 (no !==) evita que ese
              // null cuele aquí sin dar rol en getUserRol (rutas bloqueadas).
              if (
                (userOU.idCedesca > 0 || userOU.idCntec > 0) &&
                navi.id !== SIDEBAR_OPTIONS.FACTURAS &&
                navi.id !== SIDEBAR_OPTIONS.RECIBOS &&
                navi.id !== SIDEBAR_OPTIONS.FACTURAR_RECIBOS &&
                navi.id !== SIDEBAR_OPTIONS.CLIENTES &&
                (navi.id === 1 || navi.id === 5)
              ) {
                return (
                  <NavItemContainer
                    key={navi.id}
                    id={navi.id}
                    //toggle={() => toggle(navi.id)}
                    className={location.pathname === navi.href ? 'activeLink' : ''}
                    to={navi.href}
                    title={navi.title}
                    suffix={navi.suffix}
                    suffixColor={navi.suffixColor}
                    icon={navi.icon}
                  />
                );
              }

              // Usuario con rol de Sede
              // Lo ve todo menos "Logs" y "Cálculo de notas"
              if (
                userOU.idCedesca === -1 &&
                userOU.idCntec === -1 &&
                navi.id !== 6 &&
                navi.id !== 7 &&
                navi.id !== SIDEBAR_OPTIONS.SUPLANTACION_IDENTIDAD &&
                navi.id !== SIDEBAR_OPTIONS.AJUSTES &&
                navi.id !== SIDEBAR_OPTIONS.FACTURAS &&
                navi.id !== SIDEBAR_OPTIONS.RECIBOS &&
                navi.id !== SIDEBAR_OPTIONS.FACTURAR_RECIBOS &&
                navi.id !== SIDEBAR_OPTIONS.CLIENTES
              ) {
                return (
                  <NavItemContainer
                    key={navi.id}
                    id={navi.id}
                    //toggle={() => toggle(navi.id)}
                    className={location.pathname === navi.href ? 'activeLink' : ''}
                    to={navi.href}
                    title={navi.title}
                    suffix={navi.suffix}
                    suffixColor={navi.suffixColor}
                    icon={navi.icon}
                  />
                );
              }

              // Usuario con rol de Orientación
              // Solo "Alumnos" y "Matrículas" - de sus alumnos
              if (
                userOU.idCedesca === -2 &&
                userOU.idCedesca === -2 &&
                (navi.id === 1 ||
                  (navi.id === 5 &&
                    navi.id !== SIDEBAR_OPTIONS.FACTURAS &&
                    navi.id !== SIDEBAR_OPTIONS.RECIBOS &&
                    navi.id !== SIDEBAR_OPTIONS.FACTURAR_RECIBOS &&
                    navi.id !== SIDEBAR_OPTIONS.CLIENTES))
              ) {
                return (
                  <NavItemContainer
                    key={navi.id}
                    id={navi.id}
                    //toggle={() => toggle(navi.id)}
                    className={location.pathname === navi.href ? 'activeLink' : ''}
                    to={navi.href}
                    title={navi.title}
                    suffix={navi.suffix}
                    suffixColor={navi.suffixColor}
                    icon={navi.icon}
                  />
                );
              }

              // Usuario con rol de Secretaría
              // Lo ve todo menos "Logs" y "Cálculo de notas"
              if (
                userOU.idCedesca === -3 &&
                userOU.idCntec === -3 &&
                navi.id !== 6 &&
                navi.id !== 7 &&
                navi.id !== SIDEBAR_OPTIONS.SUPLANTACION_IDENTIDAD &&
                navi.id !== SIDEBAR_OPTIONS.AJUSTES &&
                navi.id !== SIDEBAR_OPTIONS.FACTURAS &&
                navi.id !== SIDEBAR_OPTIONS.RECIBOS &&
                navi.id !== SIDEBAR_OPTIONS.FACTURAR_RECIBOS &&
                navi.id !== SIDEBAR_OPTIONS.CLIENTES
              ) {
                return (
                  <NavItemContainer
                    key={navi.id}
                    id={navi.id}
                    //toggle={() => toggle(navi.id)}
                    className={location.pathname === navi.href ? 'activeLink' : ''}
                    to={navi.href}
                    title={navi.title}
                    suffix={navi.suffix}
                    suffixColor={navi.suffixColor}
                    icon={navi.icon}
                  />
                );
              }

              // Si aún no se ha obtenido el rol, solo mostramos la página inicial "Alumnos"
              if (userOU.idCedesca === -4 && userOU.idCntec === -4 && navi.id === 1) {
                return (
                  <NavItemContainer
                    key={navi.id}
                    id={navi.id}
                    //toggle={() => toggle(navi.id)}
                    className={location.pathname === navi.href ? 'activeLink' : ''}
                    to={navi.href}
                    title={navi.title}
                    suffix={navi.suffix}
                    suffixColor={navi.suffixColor}
                    icon={navi.icon}
                  />
                );
              }

              return <div key={navi.id}></div>;
            })}
          </Nav>
        </div>
      </SimpleBar>
    </div>
  );
};

export default Sidebar;
